import Grid from '@mui/material/Grid';
import { _ } from '/@/locale';
import styles from '../styles.module.css';

const SelectPlaceholder = ({ text }) => {
    return (
        <Grid container justifyContent='space-between' alignItems='center'>
            <Grid item xs={9}>
                {_(text)}
            </Grid>
            <Grid item xs={3} className={styles.selectDate}>
                <i className='material-icons'>date_range</i>
            </Grid>
        </Grid>
    );
};

export default SelectPlaceholder;
